<template>
  <v-container fluid>
    <!-- <v-container fluid> -->
    <v-row>
      <global-EventFilterMenu header="Event Filter" />
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-speedometer </v-icon>
            Totals
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="homeTotalsLoading">
                  <v-card class="primary" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-cash </v-icon>
                      Gross Sales:
                    </v-card-title>
                    <v-card-text
                      class="headline font-weight-bold"
                      v-if="homeTotals.hasOwnProperty('totals_data')"
                    >
                      {{
                        homeTotals.totals_data.grossSales !== undefined
                          ? homeTotals.totals_data.grossSales
                          : "N/A" | currency
                      }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="homeTotalsLoading">
                  <v-card class="primary" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-cash </v-icon>
                      Net Sales:
                    </v-card-title>
                    <v-card-text
                      class="headline font-weight-bold"
                      v-if="homeTotals.hasOwnProperty('totals_data')"
                    >
                      {{
                        homeTotals.totals_data.netSales !== undefined
                          ? homeTotals.totals_data.netSales
                          : "N/A" | currency
                      }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="homeTotalsLoading">
                  <v-card class="primary" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-account-multiple </v-icon>
                      Headcount:
                      <v-icon
                        v-if="IsAdmin"
                        small
                        class="ml-2"
                        @click="startEditingHeadcount"
                      >
                        mdi-pencil
                      </v-icon>
                    </v-card-title>
                    <v-card-text class="headline font-weight-bold">
                      <template v-if="!isEditingHeadcount">
                        {{
                          homeTotals.event_metadata &&
                          homeTotals.event_metadata.headcount !== undefined
                            ? this.$options.filters.number(
                                homeTotals.event_metadata.headcount
                              )
                            : 0
                        }}
                      </template>
                      <template v-else>
                        <v-text-field
                          v-model="editedHeadcount"
                          type="number"
                          dense
                          hide-details
                          class="mt-0 pt-0"
                          @keyup.enter="saveHeadcount"
                        >
                          <template v-slot:append>
                            <v-icon
                              small
                              color="success"
                              class="mr-1"
                              @click="saveHeadcount"
                              >mdi-check</v-icon
                            >
                            <v-icon
                              small
                              color="error"
                              @click="cancelEditHeadcount"
                              >mdi-close</v-icon
                            >
                          </template>
                        </v-text-field>
                      </template>
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="homeTotalsLoading">
                  <v-card class="primary" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-account-group </v-icon>
                      Spend Per Head:
                    </v-card-title>
                    <v-card-text
                      class="headline font-weight-bold"
                      v-if="homeTotals.hasOwnProperty('totals_data')"
                    >
                      {{
                        homeTotals.totals_data.spendPerHead !== undefined
                          ? homeTotals.totals_data.spendPerHead
                          : "N/A" | currency
                      }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="homeTotalsLoading">
                  <v-card class="primary" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-swap-horizontal </v-icon>
                      Total Transactions:
                    </v-card-title>
                    <v-card-text
                      class="headline font-weight-bold"
                      v-if="homeTotals.hasOwnProperty('totals_data')"
                    >
                      {{
                        homeTotals.totals_data.totalTransactions !== undefined
                          ? this.$options.filters.number(
                              homeTotals.totals_data.totalTransactions
                            )
                          : "N/A"
                      }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>
              <v-col lg="6" md="12" sm="6" cols="12">
                <skeletons-summary :loading="homeTotalsLoading">
                  <v-card class="primary" dark>
                    <v-card-title class="py-1 text-subtitle-1">
                      <v-icon left> mdi-calculator </v-icon>
                      Avg Transaction Value:
                    </v-card-title>
                    <v-card-text
                      class="headline font-weight-bold"
                      v-if="homeTotals.hasOwnProperty('totals_data')"
                    >
                      {{
                        homeTotals.totals_data.avgTransactionValue !== undefined
                          ? homeTotals.totals_data.avgTransactionValue
                          : "N/A" | currency
                      }}
                    </v-card-text>
                  </v-card>
                </skeletons-summary>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-podium </v-icon>
            Top 10 Stalls
          </v-card-title>
          <skeletons-table :loading="homeTotalsLoading">
            <v-card-text class="pa-0">
              <tables-simple
                :tableHeadings="topStalls.headings"
                :tableDataProperties="topStalls.dataProperties"
                :tableData="processedTopStallsData"
                :ranks="true"
              />
            </v-card-text>
          </skeletons-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-podium </v-icon>
            Top 10 Products
          </v-card-title>
          <skeletons-table :loading="homeTotalsLoading">
            <v-card-text class="pa-0">
              <tables-simple
                :tableHeadings="topProducts.headings"
                :tableDataProperties="topProducts.dataProperties"
                :tableData="processedTopProductsData"
                :ranks="true"
              />
            </v-card-text>
          </skeletons-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-podium </v-icon>
            Top 10 Terminals
          </v-card-title>
          <skeletons-table :loading="homeTotalsLoading">
            <v-card-text class="pa-0">
              <tables-simple
                :tableHeadings="topTerminals.headings"
                :tableDataProperties="topTerminals.dataProperties"
                :tableData="processedTopTerminalsData"
                :ranks="true"
              />
            </v-card-text>
          </skeletons-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-podium </v-icon>
            Top 10 Stall Tags
          </v-card-title>
          <skeletons-table :loading="homeTotalsLoading">
            <v-card-text class="pa-0">
              <tables-simple
                v-if="processedTopStallTagsData.length > 0"
                :tableHeadings="topStallTags.headings"
                :tableDataProperties="topStallTags.dataProperties"
                :tableData="processedTopStallTagsData"
                :ranks="true"
              />
              <v-simple-table v-else light dense>
                <tbody>
                  <tr>
                    <td class="text-center grey--text" colspan="5">
                      No data available for this event
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </skeletons-table>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>

import iziToast from "izitoast/dist/js/iziToast.min.js";
import "izitoast/dist/css/iziToast.min.css";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    grossSales: "",
    netSales: "",
    avgTransactionValue: "",
    spendPerHead: "",
    totalTransactions: "",
    processedTopProductsData: [],
    processedTopStallsData: [],
    processedTopTerminalsData: [],
    processedTopStallTagsData: [],

    topStalls: {
      headings: ["Rank", "Stall Name", "Sales"],
      dataProperties: ["Stall Name", "Sales"],
    },
    topProducts: {
      headings: ["Rank", "Product Name", "Category", "Quantity", "Gross Sales"],
      dataProperties: [
        "Product Name",
        "Category Name",
        "Quantity",
        "Gross Sales",
      ],
    },
    topTerminals: {
      headings: ["Rank", "Stall Name", "Terminal Number", "Terminal Sales"],
      dataProperties: ["Stall Name", "Terminal Number", "Terminal Sales"],
    },
    topStallTags: {
      headings: ["Rank", "Tag Name", "Transactions", "Net Sales", "Gross Sales"],
      dataProperties: ["Tag Name", "Transactions", "Net Sales", "Gross Sales"],
    },
    eventMetadata: {
      headcount: 0,
    },
    isEditingHeadcount: false,
    editedHeadcount: 0,
  }),
  computed: {
    ...mapState("dashboard", ["homeTotals", "homeTotalsLoading"]),
    ...mapState("filter", ["IsAdmin", "globalEventFilter"]),
  },
  methods: {
    // ...mapActions('dashboard', ['updateDashboard']),
    ...mapActions("admin", ["createEvent"]),

    processTopStallsData() {
      if (
        this.homeTotals &&
        this.homeTotals.top_stalls_data &&
        this.homeTotals.top_stalls_data.length > 0
      ) {
        this.processedTopStallsData = this.homeTotals.top_stalls_data.map(
          (item) => ({
            ...item,
            Sales:
              item.Sales !== undefined
                ? this.$options.filters.currency(item.Sales)
                : "N/A",
          })
        );
      } else {
        // Clear old data when no new data is available
        this.processedTopStallsData = [];
      }
    },
    processTopProductsData() {
      if (
        this.homeTotals &&
        this.homeTotals.top_products_data &&
        this.homeTotals.top_products_data.length > 0
      ) {
        this.processedTopProductsData = this.homeTotals.top_products_data.map(
          (item) => ({
            ...item,
            Quantity:
              item.Quantity !== undefined
                ? this.$options.filters.number(item.Quantity)
                : "N/A",
            "Gross Sales":
              item["Gross Sales"] !== undefined
                ? this.$options.filters.currency(item["Gross Sales"])
                : "N/A",
            "Net Sales":
              item["Net Sales"] !== undefined
                ? this.$options.filters.currency(item["Net Sales"])
                : "N/A",
          })
        );
      } else {
        // Clear old data when no new data is available
        this.processedTopProductsData = [];
      }
    },
    processTopTerminalsData() {
      if (
        this.homeTotals &&
        this.homeTotals.top_terminals_data &&
        this.homeTotals.top_terminals_data.length > 0
      ) {
        this.processedTopTerminalsData = this.homeTotals.top_terminals_data.map(
          (item) => ({
            ...item,
            "Terminal Sales":
              item["Terminal Sales"] !== undefined
                ? this.$options.filters.currency(item["Terminal Sales"])
                : "N/A",
          })
        );
      } else {
        // Clear old data when no new data is available
        this.processedTopTerminalsData = [];
      }
    },
    processTopStallTagsData() {
      const tags = this.homeTotals && this.homeTotals.stalltags;
      if (tags && typeof tags === "object" && Object.keys(tags).length > 0) {
        this.processedTopStallTagsData = Object.values(tags).map((item) => ({
          "Tag Name": item.StallTagName,
          Transactions:
            item.TransactionCount !== undefined
              ? this.$options.filters.number(item.TransactionCount)
              : "N/A",
          "Net Sales":
            item.NettSales !== undefined
              ? this.$options.filters.currency(item.NettSales)
              : "N/A",
          "Gross Sales":
            item.GrossSales !== undefined
              ? this.$options.filters.currency(item.GrossSales)
              : "N/A",
        }));
      } else {
        // Clear old data when no new data is available
        this.processedTopStallTagsData = [];
      }
    },
    startEditingHeadcount() {
      console.log("homeTotals: ", this.homeTotals);
      this.editedHeadcount =
        this.homeTotals.event_metadata &&
        this.homeTotals.event_metadata.headcount !== undefined
          ? this.homeTotals.event_metadata.headcount
          : 0;
      this.isEditingHeadcount = true;
    },
    async saveHeadcount() {
      try {
        const event_item = {
          Type: "UpdateHeadcount",
          Properties: {
            EventId: this.globalEventFilter.EventId,
            Headcount: Number(this.editedHeadcount),
          },
        };
        await this.createEvent(event_item);
        // // Update local state - ensure event_metadata exists
        if (!this.homeTotals.event_metadata) {
          this.homeTotals.event_metadata = {};
        }
        this.homeTotals.event_metadata.headcount = Number(this.editedHeadcount);
        this.isEditingHeadcount = false;

        // Show success message
        iziToast.success({
          title: "Success",
          message: "Headcount updated successfully",
          position: "topRight",
        });
      } catch (error) {
        console.error("Error saving headcount:", error);
        iziToast.error({
          title: "Error",
          message: "Failed to update headcount",
          position: "topRight",
        });
      }
    },
    cancelEditHeadcount() {
      this.isEditingHeadcount = false;
      this.editedHeadcount = null;
    },
  },
  filters: {
    currency(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return "$" + formatter.format(value);
    },
    number(value) {
      var formatter = new Intl.NumberFormat("en-AU", {
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },

  watch: {
    "homeTotals.top_stalls_data": {
      handler() {
        this.processTopStallsData();
      },
      immediate: true,
    },
    "homeTotals.top_products_data": {
      handler() {
        this.processTopProductsData();
      },
      immediate: true,
    },
    "homeTotals.top_terminals_data": {
      handler() {
        this.processTopTerminalsData();
      },
      immediate: true,
    },
    "homeTotals.stalltags": {
      handler() {
        this.processTopStallTagsData();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
body {
  background-color: #000000;
}
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
p {
  color: #6e6e6e;
  font-family: sans-serif;
}
</style>
